import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import fingerprint from "./Images/fing3.png";

function FingerprintScreen() {
  const [credentialId, setCredentialId] = useState(null);

  const navigate = useNavigate();

  const registerFingerprint = async () => {
    try {
      const challenge = new Uint8Array(32);
      crypto.getRandomValues(challenge);

      const userId = new Uint8Array(16);
      crypto.getRandomValues(userId);

      const credential = await navigator.credentials.create({
        publicKey: {
          challenge,
          rp: {
            name: "My Attendance App"
          },
          user: {
            id: userId,
            name: "user@example.com",
            displayName: "Employee"
          },
          pubKeyCredParams: [
            {
              type: "public-key",
              alg: -7
            }
          ],
          authenticatorSelection: {
            authenticatorAttachment: "platform",
            userVerification: "required"
          },
          timeout: 60000,
          attestation: "none"
        }
      });

      const idArray = Array.from(
        new Uint8Array(credential.rawId)
      );

      localStorage.setItem(
        "credentialId",
        JSON.stringify(idArray)
      );

      setCredentialId(idArray);

      alert("Fingerprint Registered Successfully");
    } catch (err) {
      console.error(err);
      alert("Registration Failed");
    }
  };

  const verifyFingerprint = async () => {
    try {
      const stored = localStorage.getItem("credentialId");

      if (!stored) {
        alert("Please register fingerprint first");
        return;
      }

      const challenge = new Uint8Array(32);
      crypto.getRandomValues(challenge);

      const assertion = await navigator.credentials.get({
        publicKey: {
          challenge,
          allowCredentials: [
            {
              id: new Uint8Array(JSON.parse(stored)),
              type: "public-key",
              transports: ["internal"]
            }
          ],
          userVerification: "required",
          timeout: 60000
        }
      });

      console.log(assertion);

      alert("Fingerprint Verified Successfully");

      // Navigate to ShopFloor page
      navigate("/ShopFloor");

    } catch (err) {
      console.error(err);
      alert("Verification Failed");
    }
  };

  return (
    <div
      style={{
        textAlign: "center",
        marginTop: "50px"
      }}
    >
      <h2>Fingerprint Authentication</h2>

      <button
        onClick={registerFingerprint}
        style={{
          padding: "10px 20px",
          marginBottom: "20px"
        }}
      >
        Register Fingerprint
      </button>

      <br />

      <button
        onClick={verifyFingerprint}
        style={{
          border: "none",
          background: "transparent",
          cursor: "pointer"
        }}
      >
        <img
          src={fingerprint}
          alt="Fingerprint"
          width="150"
          height="150"
        />
      </button>

      <p>Tap fingerprint to verify</p>
    </div>
  );
}

export default FingerprintScreen;